export default __webpack_public_path__ + "static/media/instructions-obstacles.21ce9635.png";